import * as React from 'react';

import Retry16 from './Retry16';

export const retry16 = () => <Retry16 />;

export default {
    title: 'Icon/Line/Retry16',
    component: Retry16,
    parameters: {
        notes: "`import Retry16 from 'box-ui-elements/es/icon/line/Retry16';`",
    },
};
